/*import * as compression from "compression";
import * as express from "express";
import { Express } from "express";
import { Server } from "https";
import { inject, injectable } from 'inversify';
import { BobrequestPipelineFactory } from "../domain/factories/bobrequest-pipeline-factory";
import { DI } from '../infrastructure/di';
import { BOBEnvironment } from "./bob-environment";
import { DomainPolicy } from "./domain-policy";
import { Passthrough } from "./passthrough";
import { RequestHandler } from "./request-handler";

import * as https from "https";
import * as AWSXRay from "aws-xray-sdk";
const RollbarTracking = BOBEnvironment.getRollbar();*/

import * as compression from "compression";
import { Express } from "express";
import * as express from "express";
import * as https from "https";
import { Server } from "https";
import { inject, injectable } from "inversify";
import { BobrequestPipelineFactory } from "../domain/factories/bobrequest-pipeline-factory";
import { DI } from "../infrastructure/di";
import { BOBEnvironment } from "./bob-environment";
import { DomainPolicy } from "./domain-policy";
import { ErrorMiddleware } from "./error-middleware";
import { Passthrough } from "./passthrough";
import { RequestHandler } from "./request-handler";
import * as AWSXRay from "aws-xray-sdk";

@injectable()
export class BobServer {

	private app: Express;
	private server: Server | Express;

	constructor(
		@inject(DI.BOB_PORT) private port: number,
		@inject(DI.DOMAIN_POLICY) private domainPolicy: DomainPolicy,
		@inject(DI.BOB_REQUEST_PIPELINE_FACTORY) private bobRequestPipelineFactory: BobrequestPipelineFactory,
		@inject(DI.PASSTHROUGH) private passthrough: Passthrough,
		@inject(DI.ERROR_MIDDLEWARE) private errorMiddleware: ErrorMiddleware
	) {
	}

	public initialize(): void {
		this.app = express();

		AWSXRay.enableManualMode();

		this.setupMiddleware();
		this.createServer();
		this.startServer();
		this.setupRequestHandler();
	}

	private setupMiddleware(): void {

		// gzip all the things
		this.app.use(compression());
		this.app.use(this.domainPolicy.getHandler());
		this.app.use(this.passthrough.getHandler());
		this.app.use(this.errorMiddleware.getHandler());
	}

	private createServer(): void {

		this.server = this.app;

		if (BOBEnvironment.useHttps()) {

			this.server = https.createServer({
				SNICallback(domain, cb) {

					return cb(null, BOBEnvironment.getSecureContext(domain));
				}
			}, this.app);
		}
	}

	private startServer(): void {

		this.server.listen(this.port, () => {
			// tslint:disable-next-line
			console.info(`Bob is running on port ${this.port}`);
		});
	}

	private setupRequestHandler(): void {

		const requestHandler = new RequestHandler(this.bobRequestPipelineFactory);

		this.app.use(AWSXRay.express.openSegment("BobTheCompositor"));
		this.app.get("*", requestHandler.getHandler());
		this.app.use(AWSXRay.express.closeSegment());
	}
}
